import { keyframes } from "@emotion/core"
import {
  Cell,
  Grid,
  HFlow,
  Icon,
  Text,
  TextProps,
  Theme,
  useStyles,
  VFlow,
} from "bold-ui"
import { useIntl } from "gatsby-plugin-intl"
import { Image } from "../components/mdx"
import React from "react"
import { withPrefix } from "gatsby"

import { PageLayout } from "../components/PageLayout"

export default () => {
  const { classes } = useStyles(createStyles)
  const intl = useIntl()

  return (
    <PageLayout container={false}>
      <div className={classes.wrapper}>
        <div className={classes.container}>
          <h1 className={classes.title}>
            <AnimatedTitle>b_thinking</AnimatedTitle>{" "}
            <span style={{ display: "inline-block" }}>
              user experience process model
            </span>
          </h1>

          <VFlow vSpacing={2}>
            <VFlow>
              <h2 className={classes.subtitle}>
                {intl.formatMessage({ id: "home-welcome" })}
              </h2>
            </VFlow>

            <Grid wrap>
              <Cell xs={12} md={6}>
                <HFlow alignItems="center" hSpacing={0.5}>
                  <Icon icon="arrowRight" fill="primary" />
                  <h3 className={classes.infoTitle}>
                    {intl.formatMessage({ id: "home-steps-title" })}
                  </h3>
                </HFlow>
                <Text component="p" style={classes.info}>
                  {intl.formatMessage({ id: "home-steps-description" })}
                </Text>
              </Cell>
              <Cell xs={12} md={6}>
                <HFlow alignItems="center" hSpacing={0.5}>
                  <Icon icon="arrowRight" fill="primary" />
                  <h3 className={classes.infoTitle}>
                    {intl.formatMessage({ id: "home-principles-title" })}
                  </h3>
                </HFlow>
                <Text component="p" style={classes.info}>
                  {intl.formatMessage({ id: "home-principles-description" })}
                </Text>
              </Cell>
              <Cell xs={12} md={6}>
                <HFlow alignItems="center" hSpacing={0.5}>
                  <Icon icon="arrowRight" fill="primary" />
                  <h3 className={classes.infoTitle}>
                    {intl.formatMessage({ id: "home-methods-title" })}
                  </h3>
                </HFlow>
                <Text component="p" style={classes.info}>
                  {intl.formatMessage({ id: "home-methods-description" })}
                </Text>
              </Cell>
              <Cell xs={12} md={6}>
                <HFlow alignItems="center" hSpacing={0.5}>
                  <Icon icon="arrowRight" fill="primary" />
                  <h3 className={classes.infoTitle}>
                    {intl.formatMessage({ id: "home-template-title" })}
                  </h3>
                </HFlow>
                <Text component="p" style={classes.info}>
                  {intl.formatMessage({ id: "home-template-description" })}
                </Text>
              </Cell>
            </Grid>
          </VFlow>
        </div>
        <div className={classes.imgBackground}>
          <Image
            style={{ display: "inherit" }}
            src={withPrefix("/image/ilustracao.svg") }
            alt="Siga o Laboratório no Instagram"
          />
        </div>
      </div>
    </PageLayout>
  )
}

function AnimatedTitle(props: TextProps) {
  const shine = keyframes({
    to: {
      backgroundPosition: "200% center",
    },
  })
  const { classes } = useStyles(createStyles, shine)

  return <Text style={classes.animatedTitle} {...props} />
}

const createStyles = (theme: Theme, shine = "") => ({
  wrapper: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  } as React.CSSProperties,
  container: {
    padding: "48px 80px 0",
    maxWidth: 1056,
    [theme.breakpoints.down("sm")]: {
      padding: 40,
    },
  } as React.CSSProperties,
  img: {
    maxWidth: "inherite",
  } as React.CSSProperties,
  title: {
    fontWeight: "normal",
    fontSize: 36,
    lineHeight: "56px",
    [theme.breakpoints.down("sm")]: {
      fontSize: 24,
      lineHeight: "40px",
    },
  } as React.CSSProperties,
  subtitle: {
    fontSize: 23,
    fontWeight: "normal",
    marginTop: "1.5rem",
    marginBottom: "4rem",
  } as React.CSSProperties,
  animatedTitle: {
    fontSize: 72,
    lineHeight: 1,
    fontWeight: "bold",
    background:
      "linear-gradient(80deg, #007AF0 20%, #00B5FF 40%, #00D2F4 60%, #007AF0 80%)",
    backgroundClip: "text",
    textFillColor: "transparent",
    WebkitTextFillColor: "transparent",
    WebkitBackgroundClip: "text",
    backgroundSize: "200% auto",
    animation: `${shine} 2s linear infinite`,
  } as React.CSSProperties,
  divider: {
    width: 100,
    marginBottom: "4rem",
    marginTop: "2rem",
  },
  info: {
    marginLeft: 32,
    marginTop: 8,
    fontSize: "1rem",
  },
  infoTitle: {
    fontSize: "1.5rem",
  },
  imgBackground: {
    maxWidth: "1056px",
  },
})
